import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { roPlants } from '../../mock/mockData';

const ROPlant3000LPH = () => {
  const productData = roPlants.find(p => p.id === 'ro-3000');
  return <ProductPageTemplate productData={productData} />;
};

export default ROPlant3000LPH;